// import {
//   Checkbox,
//   Group,
//   Input,
//   MultiSelect,
//   NumberInput,
//   Radio,
//   Select,
//   Stack,
//   Textarea,
//   TextInput,
// } from "@mantine/core";
// import { DateInput, DateTimePicker, TimeInput } from "@mantine/dates";
// import { useField, UseFormReturnType } from "@mantine/form";
// import { useUncontrolled } from "@mantine/hooks";
// import { useQuery } from "@tanstack/react-query";
// import { isArray, isDate, isNil, map } from "lodash";
// import { useEffect, useState } from "react";
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";
// import axios from "../../../../libs/axios";
// import { CLIENT_ID } from "../../../../constants/Settings";
// import { store } from "../../../../store/useStore";
// import { Else, If, Then } from "react-if";
// import dayjs from "dayjs";

// const _authState = store.auth.state();

// function TextField({
//   form,
//   value,
//   field,
//   fields,
//   handleChange,
// }: {
//   form: any;
//   value: any;
//   field: any;
//   fields: any;
//   handleChange: any;
// }) {
//   const _field = useField({
//     initialValue: value ?? "",
//     onValueChange: (value) => {
//       handleChange(value);
//     },
//     validateOnChange: true,
//     validate: (value) => {
//       if (field?.validations?.required && value === "") {
//         return "Field is required";
//       }
//       if (field?.validations?.min && value.length < field.validations.min) {
//         return `Minimum ${field.validations.min} characters`;
//       }
//       if (field?.validations?.max && value.length > field.validations.max) {
//         return `Maximum ${field.validations.max} characters`;
//       }
//     },
//   });

//   return (
//     <>
//       <TextInput
//         label={field.label}
//         placeholder={field.placeholder}
//         readOnly={field?.is_readonly === 1 ? true : false}
//         disabled={field?.is_readonly === 1 ? true : false}
//         withAsterisk={field?.validations?.required}
//         {..._field.getInputProps()}
//       />
//     </>
//   );
// }

// function NumberField({
//   form,
//   value,
//   field,
//   fields,
//   handleChange,
// }: {
//   form: any;
//   value: any;
//   field: any;
//   fields: any;
//   handleChange: any;
// }) {
//   const _field = useField({
//     initialValue: value ?? "",
//     onValueChange: (value) => {
//       handleChange(value);
//     },
//     validateOnChange: true,
//     validate: (value) => {
//       if (field?.validations?.required && value === "") {
//         return "Field is required";
//       }
//       //   if (field?.validations?.min && value.length < field.validations.min) {
//       //     return `Minimum ${field.validations.min}`;
//       //   }
//       //   if (field?.validations?.max && value.length > field.validations.max) {
//       //     return `Maximum ${field.validations.max} characters`;
//       //   }

//       if (field?.validations?.min && value < field.validations.min) {
//         return `Minimum ${field.validations.min}`;
//       }
//       if (field?.validations?.max && value > field.validations.max) {
//         return `Maximum ${field.validations.max}`;
//       }
//     },
//   });

//   return (
//     <NumberInput
//       label={field.label}
//       placeholder={field.placeholder}
//       readOnly={field?.is_readonly === 1 ? true : false}
//       disabled={field?.is_readonly === 1 ? true : false}
//       withAsterisk={field?.validations?.required}
//       {..._field.getInputProps()}
//     />
//   );
// }

// function PhoneNumberField({
//   form,
//   value,
//   field,
//   fields,
//   handleChange,
// }: {
//   form: any;
//   value: any;
//   field: any;
//   fields: any;
//   handleChange: any;
// }) {
//   const _field = useField({
//     initialValue: value ?? "",
//     onValueChange: (value) => {
//       handleChange(value);
//     },
//     validateOnChange: true,
//     validate: (value) => {
//       if (field?.validations?.required && value === "") {
//         return "Field is required";
//       }
//     },
//   });

//   return (
//     <Stack gap={6}>
//       <Input.Label required={field?.validations?.required} size="sm">
//         {field.label}
//       </Input.Label>
//       <PhoneInput
//         enableSearch
//         // disableCountryCode
//         disabled={field?.is_readonly === 1 ? true : false}
//         disableSearchIcon
//         disableDropdown
//         value={_field.getValue().replace("-", "").replace("+", "")}
//         country="in"
//         inputStyle={{
//           width: "100%",
//           borderRadius: 8,
//           height: 42,
//         }}
//         onChange={(phone, country) => {
//           _field.setValue(
//             `+${(country as any)?.dialCode}-${phone.slice(
//               (country as any)?.dialCode?.length
//             )}`
//           );
//         }}
//       />

//       {_field.error && <Input.Error>{_field.error}</Input.Error>}
//     </Stack>
//   );
// }

// function SelectField({
//   form,
//   value,
//   field,
//   fields,
//   handleChange,
// }: {
//   form: any;
//   value: any;
//   field: any;
//   fields: any;
//   handleChange: any;
// }) {
//   const [fieldOptions, setFieldOptions] = useState<any>([]);

//   const _field = useField({
//     initialValue: value ?? "",
//     onValueChange: (value) => {
//       handleChange(value);
//     },
//     validateOnChange: true,
//     validate: (value) => {
//       if (field?.validations?.required && value === "") {
//         return "Field is required";
//       }
//     },
//   });

//   useEffect(() => {
//     if (field?.field_options?.type === "manual") {
//       setFieldOptions(field?.field_options?.options);
//     }
//   }, [field]);

//   return (
//     <Select
//       label={field.label}
//       placeholder={field.placeholder}
//       readOnly={field?.is_readonly === 1 ? true : false}
//       disabled={field?.is_readonly === 1 ? true : false}
//       withAsterisk={field?.validations?.required}
//       data={fieldOptions}
//       {..._field.getInputProps()}
//     />
//   );
// }

// function APISelectField({
//   form,
//   value,
//   field,
//   fields,
//   handleChange,
// }: {
//   form: UseFormReturnType<
//     Record<string, any>,
//     (values: Record<string, any>) => Record<string, any>
//   >;
//   value: any;
//   field: any;
//   fields: any[];
//   handleChange: any;
// }) {
//   const url = map(field?.assigned_field_options?.params, (value) => {
//     return `${value.name}=${form.values[value.form_field_key ?? ""]}`;
//   }).join("&");

//   //   const [fieldOptions, setFieldOptions] = useState<any>([]);

//   const { data: values, refetch } = useQuery({
//     queryKey: [field?.field_options?.url],
//     queryFn: async () => {
//       const { data: response } = await axios.get(
//         field?.assigned_field_options?.is_dependent
//           ? `${field?.field_options?.url}${
//               field?.field_options?.is_already_param_exist ? "&" : ""
//             }${
//               field?.field_options?.is_already_param_exist
//                 ? `${url}`
//                 : `?${url}`
//             }`
//           : field?.field_options?.url,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             // Authorization: `Bearer ${_authState.authToken}`,
//             "fi-client-number": CLIENT_ID.toUpperCase(),
//             "fi-device-number": _authState.activeDeviceIdentifier,
//           },
//         }
//       );

//       const records = isArray(response?.data?.recordsInfo)
//         ? response?.data?.recordsInfo
//         : isArray(response?.data)
//         ? response?.data
//         : [];

//       const value = records.map((data: any) => {
//         return {
//           label: data.label,
//           value: String(data.value),
//         };
//       });

//       return value;
//     },
//     enabled: field?.assigned_field_options?.is_dependent ? false : true,
//     refetchOnWindowFocus: false,
//   });

//   const hasValue =
//     form.values[field?.assigned_field_options?.parent_field_name ?? ""];

//   useEffect(() => {
//     if (hasValue !== null && hasValue !== undefined && hasValue !== "") {
//       refetch();
//     }
//   }, [hasValue, refetch]);

//   return (
//     <>
//       <Select
//         clearable
//         searchable
//         label={field.label}
//         placeholder={field.placeholder}
//         withAsterisk={field?.validations?.required}
//         readOnly={field?.is_readonly === 1 ? true : false}
//         disabled={field?.is_readonly === 1 ? true : false}
//         data={
//           field?.assigned_field_options?.is_dependent && hasValue
//             ? values ?? []
//             : !field?.assigned_field_options?.is_dependent
//             ? values ?? []
//             : []
//         }
//         {...form.getInputProps(field.name)}
//         onChange={(value) => {
//           handleChange(value);

//           field?.assigned_field_options?.children_fields?.forEach(
//             (field: any) => {
//               const childrenField = fields.find(
//                 (value) => value.name === field
//               );

//               const isArrayField =
//                 childrenField.type === "checkbox" ||
//                 childrenField.type === "multi_select";

//               form.setFieldValue(field, isArrayField ? [] : null);
//             }
//           );
//         }}
//       />
//     </>
//   );
// }

// function MultiSelectField({
//   form,
//   value,
//   field,
//   fields,
//   handleChange,
// }: {
//   form: any;
//   value: any;
//   field: any;
//   fields: any;
//   handleChange: any;
// }) {
//   const [fieldOptions, setFieldOptions] = useState<any>([]);

//   const _field = useField({
//     initialValue: value ?? "",
//     onValueChange: (value) => {
//       handleChange(value);
//     },
//     validateOnChange: true,
//     validate: (value) => {
//       if (field?.validations?.required && value === "") {
//         return "Field is required";
//       }
//     },
//   });

//   useEffect(() => {
//     if (field?.field_options?.type === "manual") {
//       setFieldOptions(field?.field_options?.options);
//     }
//   }, [field]);

//   return (
//     <MultiSelect
//       label={field.label}
//       placeholder={field.placeholder}
//       withAsterisk={field?.validations?.required}
//       readOnly={field?.is_readonly === 1 ? true : false}
//       disabled={field?.is_readonly === 1 ? true : false}
//       data={fieldOptions}
//       {..._field.getInputProps()}
//     />
//   );
// }

// function APIMultiSelectField({
//   form,
//   value,
//   field,
//   fields,
//   handleChange,
// }: {
//   form: any;
//   value: any;
//   field: any;
//   fields: any[];
//   handleChange: any;
// }) {
//   const url = map(field?.assigned_field_options?.params, (value) => {
//     return `${value.name}=${form.values[value.form_field_key ?? ""]}`;
//   }).join("&");

//   //   const [fieldOptions, setFieldOptions] = useState<any>([]);

//   const { data: values, refetch } = useQuery({
//     queryKey: [field?.field_options?.url],
//     queryFn: async () => {
//       const { data: response } = await axios.get(
//         field?.assigned_field_options?.is_dependent
//           ? `${field?.field_options?.url}${
//               field?.field_options?.is_already_param_exist ? "&" : ""
//             }${
//               field?.field_options?.is_already_param_exist
//                 ? `${url}`
//                 : `?${url}`
//             }`
//           : field?.field_options?.url,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             // Authorization: `Bearer ${Cookies.get("session")}`,
//             "fi-client-number": CLIENT_ID.toUpperCase(),
//             "fi-device-number": _authState.activeDeviceIdentifier,
//           },
//         }
//       );

//       const records = isArray(response?.data?.recordsInfo)
//         ? response?.data?.recordsInfo
//         : isArray(response?.data)
//         ? response?.data
//         : [];

//       const value = records.map((data: any) => {
//         return {
//           label: data.label,
//           value: String(data.value),
//         };
//       });

//       return value;
//     },
//     enabled: field?.assigned_field_options?.is_dependent ? false : true,
//     refetchOnWindowFocus: false,
//   });

//   const hasValue =
//     form.values[field?.assigned_field_options?.parent_field_name ?? ""];

//   useEffect(() => {
//     if (hasValue !== null && hasValue !== undefined && hasValue !== "") {
//       refetch();
//     }
//   }, [hasValue, refetch]);

//   return (
//     <>
//       <MultiSelect
//         clearable
//         searchable
//         label={field?.label}
//         placeholder={field?.placeholder}
//         withAsterisk={field?.validations?.required}
//         readOnly={field?.is_readonly === 1 ? true : false}
//         disabled={field?.is_readonly === 1 ? true : false}
//         data={
//           field?.assigned_field_options?.is_dependent && hasValue
//             ? values ?? []
//             : !field?.assigned_field_options?.is_dependent
//             ? values ?? []
//             : []
//         }
//         nothingFoundMessage="No options found"
//         {...form.getInputProps(field.name)}
//         onChange={(value) => {
//           handleChange(value);

//           field?.assigned_field_options?.children_fields?.forEach(
//             (field: any) => {
//               const childrenField = fields.find(
//                 (value) => value.name === field
//               );

//               const isArrayField =
//                 childrenField.type === "checkbox" ||
//                 childrenField.type === "multi_select";

//               form.setFieldValue(field, isArrayField ? [] : null);
//             }
//           );
//         }}
//       />
//     </>
//   );
// }

// function DateField({
//   form,
//   value,
//   field,
//   fields,
//   handleChange,
// }: {
//   form: any;
//   value: any;
//   field: any;
//   fields: any;
//   handleChange: any;
// }) {
//   const _field = useField({
//     initialValue: isNil(value)
//       ? null
//       : isDate(new Date(value))
//       ? new Date(value)
//       : null,
//     onValueChange: (value) => {
//       handleChange(value);
//     },
//     validateOnChange: true,
//     validate: (value) => {
//       if (field?.validations?.required && isNil(value)) {
//         return "Field is required";
//       }
//     },
//   });

//   return (
//     <>
//       <DateInput
//         label={field.label}
//         placeholder={field.placeholder}
//         withAsterisk={field?.validations?.required}
//         readOnly={field?.is_readonly === 1 ? true : false}
//         disabled={field?.is_readonly === 1 ? true : false}
//         {...(field?.validations?.after &&
//           !isNil(field?.validations?.after) &&
//           isDate(new Date(field?.validations?.after)) && {
//             minDate: new Date(field?.validations?.after),
//           })}
//         {...(field?.validations?.before &&
//           !isNil(field?.validations?.before) &&
//           isDate(new Date(field?.validations?.before)) && {
//             maxDate: new Date(field?.validations?.before),
//           })}
//         {...(field?.validations?.range &&
//           field?.validations?.range?.length === 2 &&
//           !isNil(field?.validations?.range[0]) &&
//           !isNil(field?.validations?.range[1]) &&
//           isDate(new Date(field?.validations?.range[0])) &&
//           isDate(new Date(field?.validations?.range[1])) && {
//             minDate: new Date(field?.validations?.range[0]),
//             maxDate: new Date(field?.validations?.range[1]),
//           })}
//         {..._field.getInputProps()}
//         onChange={(value) => {
//           _field.setValue(value);
//         }}
//       />
//     </>
//   );
// }

// function TimeField({
//   form,
//   value,
//   field,
//   fields,
//   handleChange,
// }: {
//   form: any;
//   value: any;
//   field: any;
//   fields: any;
//   handleChange: any;
// }) {
//   const _field = useField({
//     initialValue: isNil(value)
//       ? ""
//       : isDate(new Date(value))
//       ? dayjs(value).format("HH:mm:ss")
//       : "",
//     onValueChange: (value) => {
//       handleChange(value);
//     },
//     validateOnChange: true,
//     validate: (value) => {
//       if (field?.validations?.required && isNil(value)) {
//         return "Field is required";
//       }
//     },
//   });

//   return (
//     <TimeInput
//       label={field.label}
//       placeholder={field.placeholder}
//       withAsterisk={field?.validations?.required}
//       readOnly={field?.is_readonly === 1 ? true : false}
//       disabled={field?.is_readonly === 1 ? true : false}
//       {..._field.getInputProps()}
//     />
//   );
// }

// function DateTimeField({
//   form,
//   value,
//   field,
//   fields,
//   handleChange,
// }: {
//   form: any;
//   value: any;
//   field: any;
//   fields: any;
//   handleChange: any;
// }) {
//   const _field = useField({
//     initialValue: isNil(value)
//       ? null
//       : isDate(new Date(value))
//       ? new Date(value)
//       : null,
//     onValueChange: (value) => {
//       handleChange(value);
//     },
//     validateOnChange: true,
//     validate: (value) => {
//       if (field?.validations?.required && isNil(value)) {
//         return "Field is required";
//       }
//     },
//   });

//   return (
//     <DateTimePicker
//       label={field.label}
//       placeholder={field.placeholder}
//       withAsterisk={field?.validations?.required}
//       readOnly={field?.is_readonly === 1 ? true : false}
//       disabled={field?.is_readonly === 1 ? true : false}
//       {..._field.getInputProps()}
//     />
//   );
// }

// function CheckboxField({
//   form,
//   value,
//   field,
//   fields,
//   handleChange,
// }: {
//   form: any;
//   value: any;
//   field: any;
//   fields: any;
//   handleChange: any;
// }) {
//   const _field = useField({
//     initialValue: value ?? "",
//     onValueChange: (value) => {
//       handleChange(value);
//     },
//     validateOnChange: true,
//     validate: (value) => {
//       if (field?.validations?.required && value === "") {
//         return "Field is required";
//       }
//     },
//   });

//   return (
//     <Checkbox
//       label={field.label}
//       placeholder={field.placeholder}
//       readOnly={field?.is_readonly === 1 ? true : false}
//       disabled={field?.is_readonly === 1 ? true : false}
//       {..._field.getInputProps()}
//     />
//   );
// }

// function RadioField({
//   form,
//   value,
//   field,
//   fields,
//   handleChange,
// }: {
//   form: any;
//   value: any;
//   field: any;
//   fields: any;
//   handleChange: any;
// }) {
//   const [fieldOptions, setFieldOptions] = useState<any>([]);

//   const _field = useField({
//     initialValue: value ?? "",
//     onValueChange: (value) => {
//       handleChange(value);
//     },
//     validateOnChange: true,
//   });

//   useEffect(() => {
//     if (field?.field_options?.type === "manual") {
//       setFieldOptions(field?.field_options?.options);
//     }
//   }, [field]);

//   return (
//     <Radio.Group
//       label={field.label}
//       withAsterisk={field?.validations?.required}
//       readOnly={field?.is_readonly === 1 ? true : false}
//       {..._field.getInputProps()}
//     >
//       <Group mt="xs">
//         {fieldOptions?.map((option: any) => {
//           return (
//             <Radio
//               key={option.value}
//               value={option.value}
//               label={option.label}
//             />
//           );
//         })}
//       </Group>
//     </Radio.Group>
//   );
// }

// function TextAreaField({
//   form,
//   value,
//   field,
//   fields,
//   handleChange,
// }: {
//   form: any;
//   value: any;
//   field: any;
//   fields: any;
//   handleChange: any;
// }) {
//   const _field = useField({
//     initialValue: value ?? "",
//     onValueChange: (value) => {
//       handleChange(value);
//     },
//     validateOnChange: true,
//     validate: (value) => {
//       if (field?.validations?.required && value === "") {
//         return "Field is required";
//       }
//     },
//   });

//   return (
//     <Textarea
//       label={field.label}
//       placeholder={field.placeholder}
//       withAsterisk={field?.validations?.required}
//       readOnly={field?.is_readonly === 1 ? true : false}
//       disabled={field?.is_readonly === 1 ? true : false}
//       {..._field.getInputProps()}
//     />
//   );
// }

// function evaluateCondition(
//   field: string,
//   operation: string,
//   action: string,
//   value: any
// ) {
//   switch (operation) {
//     case "contains":
//       return action === "show"
//         ? field?.includes(action)
//         : !field?.includes(action);
//     case "is":
//     case "equals":
//       return action === "show" ? field === value : !field === value;
//     // return false;
//     default:
//       return false;
//   }
// }

// export default function Field({
//   form,
//   field,
//   fields,
//   value,
//   onChange,
// }: {
//   form: any;
//   field: any;
//   fields: any;
//   value: any;
//   onChange?: any;
// }) {
//   return (
//     <>
//       <If condition={field?.conditionally_visible === 1}>
//         <Then>
//           <If
//             condition={evaluateCondition(
//               form.values[field?.validations?.render_if?.field],
//               field?.validations?.render_if?.operator,
//               field?.validations?.render_if?.action,
//               field?.validations?.render_if?.value
//             )}
//           >
//             <Then>
//               <FieldByType
//                 form={form}
//                 field={field}
//                 fields={fields}
//                 value={value}
//                 onChange={onChange}
//               />
//             </Then>
//           </If>
//         </Then>
//         <Else>
//           <FieldByType
//             form={form}
//             field={field}
//             fields={fields}
//             value={value}
//             onChange={onChange}
//           />
//         </Else>
//       </If>
//     </>
//   );
// }

// function FieldByType({
//   form,
//   field,
//   fields,
//   value,
//   onChange,
// }: {
//   form: any;
//   field: any;
//   fields: any;
//   value: any;
//   onChange?: any;
// }) {
//   const _field = useField({
//     initialValue: value ?? "",
//     onValueChange: (value) => {
//       handleChange(value);
//     },
//     validateOnChange: true,
//     validate: (value) => {
//       if (field?.validations?.required && value === "") {
//         return "Field is required";
//       }
//       if (field?.validations?.min && value.length < field.validations.min) {
//         return `Minimum ${field.validations.min} characters`;
//       }
//       if (field?.validations?.max && value.length > field.validations.max) {
//         return `Maximum ${field.validations.max} characters`;
//       }
//       if (field?.type === "mobile") {
//         if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
//           return "Invalid email address";
//         }
//       }
//       if (field?.type === "number") {
//         if (!/^[0-9]+$/.test(value)) {
//           return "Invalid number";
//         }
//       }
//     },
//   });

//   const [, handleChange] = useUncontrolled({
//     value: _field.getValue(),
//     onChange: (value) => {
//       onChange(value);
//     },
//   });

//   if (field?.type === "email")
//     return (
//       <TextField
//         form={form}
//         value={value ?? ""}
//         field={field}
//         fields={fields}
//         handleChange={handleChange}
//       />
//     );

//   if (field?.type === "mobile")
//     return (
//       <PhoneNumberField
//         form={form}
//         value={value}
//         field={field}
//         fields={fields}
//         handleChange={handleChange}
//       />
//     );

//   if (field?.type === "text")
//     return (
//       <TextField
//         form={form}
//         value={value ?? ""}
//         field={field}
//         fields={fields}
//         handleChange={handleChange}
//       />
//     );

//   if (field?.type === "number")
//     return (
//       <NumberField
//         form={form}
//         value={value ?? ""}
//         field={field}
//         fields={fields}
//         handleChange={handleChange}
//       />
//     );

//   if (field?.type === "single_select") {
//     if (field?.field_options?.type === "manual") {
//       return (
//         <SelectField
//           form={form}
//           value={value ?? ""}
//           field={field}
//           fields={fields}
//           handleChange={handleChange}
//         />
//       );
//     } else if (field?.field_options?.type === "api") {
//       return (
//         <APISelectField
//           form={form}
//           value={value ?? ""}
//           field={field}
//           fields={fields}
//           handleChange={handleChange}
//         />
//       );
//     }
//   }

//   if (field?.type === "multi_select")
//     if (field?.field_options?.type === "manual") {
//       return (
//         <MultiSelectField
//           form={form}
//           value={value ?? ""}
//           field={field}
//           fields={fields}
//           handleChange={handleChange}
//         />
//       );
//     } else if (field?.field_options?.type === "api") {
//       return (
//         <APIMultiSelectField
//           form={form}
//           value={value ?? ""}
//           field={field}
//           fields={fields}
//           handleChange={handleChange}
//         />
//       );
//     }

//   if (field?.type === "radio")
//     return (
//       <RadioField
//         form={form}
//         value={value}
//         field={field}
//         fields={fields}
//         handleChange={handleChange}
//       />
//     );
//   if (field?.type === "checkbox")
//     return (
//       <CheckboxField
//         form={form}
//         value={value}
//         field={field}
//         fields={fields}
//         handleChange={handleChange}
//       />
//     );

//   if (field?.type === "date")
//     return (
//       <DateField
//         form={form}
//         value={value}
//         field={field}
//         fields={fields}
//         handleChange={handleChange}
//       />
//     );

//   if (field?.type === "time")
//     return (
//       <TimeField
//         form={form}
//         value={value}
//         field={field}
//         fields={fields}
//         handleChange={handleChange}
//       />
//     );

//   if (field?.type === "datetime")
//     return (
//       <DateTimeField
//         form={form}
//         value={value}
//         field={field}
//         fields={fields}
//         handleChange={handleChange}
//       />
//     );

//   if (field?.type === "textarea")
//     return (
//       <TextAreaField
//         form={form}
//         value={value}
//         field={field}
//         fields={fields}
//         handleChange={handleChange}
//       />
//     );

//   return <></>;
// }

// NEW CODE:
import {
  Checkbox,
  Group,
  Input,
  MultiSelect,
  NumberInput,
  Radio,
  Select,
  Stack,
  Textarea,
  TextInput,
} from "@mantine/core";
import { DateInput, DateTimePicker, TimeInput } from "@mantine/dates";
import { useField, UseFormReturnType } from "@mantine/form";
import { useUncontrolled } from "@mantine/hooks";
import { useQuery } from "@tanstack/react-query";
import { isArray, isDate, isNil, map, zipObject } from "lodash";
import { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import axios from "../../../../libs/axios";
import { CLIENT_ID } from "../../../../constants/Settings";
import { store } from "../../../../store/useStore";
import { Else, If, Then } from "react-if";

const _authState = store.auth.state();

function TextField({
  form,
  value,
  field,
  fields,
  handleChange,
}: {
  form: any;
  value: any;
  field: any;
  fields: any;
  handleChange: any;
}) {
  const _field = useField({
    initialValue: value ?? "",
    onValueChange: (value) => {
      handleChange(value);
    },
    validateOnChange: true,
    validate: (value) => {
      if (field?.validations?.required && value === "") {
        return "Field is required";
      }
      if (field?.validations?.min && value.length < field.validations.min) {
        return `Minimum ${field.validations.min} characters`;
      }
      if (field?.validations?.max && value.length > field.validations.max) {
        return `Maximum ${field.validations.max} characters`;
      }
    },
  });

  return (
    <>
      <TextInput
        label={field.label}
        placeholder={field.placeholder}
        readOnly={field?.is_readonly === 1 ? true : false}
        disabled={field?.is_readonly === 1 ? true : false}
        withAsterisk={field?.validations?.required}
        {..._field.getInputProps()}
      />
    </>
  );
}

function NumberField({
  form,
  value,
  field,
  fields,
  handleChange,
}: {
  form: any;
  value: any;
  field: any;
  fields: any;
  handleChange: any;
}) {
  const _field = useField({
    initialValue: value ?? "",
    onValueChange: (value) => {
      handleChange(value);
    },
    validateOnChange: true,
    validate: (value) => {
      if (field?.validations?.required && value === "") {
        return "Field is required";
      }
      //   if (field?.validations?.min && value.length < field.validations.min) {
      //     return `Minimum ${field.validations.min}`;
      //   }
      //   if (field?.validations?.max && value.length > field.validations.max) {
      //     return `Maximum ${field.validations.max} characters`;
      //   }

      if (field?.validations?.min && value < field.validations.min) {
        return `Minimum ${field.validations.min}`;
      }
      if (field?.validations?.max && value > field.validations.max) {
        return `Maximum ${field.validations.max}`;
      }
    },
  });

  return (
    <NumberInput
      label={field.label}
      placeholder={field.placeholder}
      readOnly={field?.is_readonly === 1 ? true : false}
      disabled={field?.is_readonly === 1 ? true : false}
      withAsterisk={field?.validations?.required}
      {..._field.getInputProps()}
    />
  );
}

function PhoneNumberField({
  form,
  value,
  field,
  fields,
  handleChange,
}: {
  form: any;
  value: any;
  field: any;
  fields: any;
  handleChange: any;
}) {
  const _field = useField({
    initialValue: value ?? "",
    onValueChange: (value) => {
      handleChange(value);
    },
    validateOnChange: true,
    validate: (value) => {
      if (field?.validations?.required && value === "") {
        return "Field is required";
      }
    },
  });

  return (
    <Stack gap={6}>
      <Input.Label required={field?.validations?.required} size="sm">
        {field.label}
      </Input.Label>
      <PhoneInput
        enableSearch
        // disableCountryCode
        disabled={field?.is_readonly === 1 ? true : false}
        disableSearchIcon
        // disableDropdown
        value={_field.getValue().replace("-", "").replace("+", "")}
        country="in"
        inputStyle={{
          width: "100%",
          borderRadius: 8,
          height: 42,
        }}
        onChange={(phone, country) => {
          _field.setValue(
            `+${(country as any)?.dialCode}-${phone.slice(
              (country as any)?.dialCode?.length
            )}`
          );
        }}
      />

      {_field.error && <Input.Error>{_field.error}</Input.Error>}
    </Stack>
  );
}

function SelectField({
  form,
  value,
  field,
  fields,
  handleChange,
}: {
  form: any;
  value: any;
  field: any;
  fields: any;
  handleChange: any;
}) {
  const [fieldOptions, setFieldOptions] = useState<any>([]);

  const _field = useField({
    initialValue: value ?? "",
    onValueChange: (value) => {
      handleChange(value);
    },
    validateOnChange: true,
    validate: (value) => {
      if (field?.validations?.required && value === "") {
        return "Field is required";
      }
    },
  });

  useEffect(() => {
    if (field?.field_options?.type === "manual") {
      setFieldOptions(field?.field_options?.options);
    }
  }, [field]);

  return (
    <Select
      label={field.label}
      placeholder={field.placeholder}
      readOnly={field?.is_readonly === 1 ? true : false}
      disabled={field?.is_readonly === 1 ? true : false}
      withAsterisk={field?.validations?.required}
      data={fieldOptions}
      {..._field.getInputProps()}
    />
  );
}

function APISelectField({
  form,
  value,
  field,
  fields,
  handleChange,
}: {
  form: UseFormReturnType<
    Record<string, any>,
    (values: Record<string, any>) => Record<string, any>
  >;
  value: any;
  field: any;
  fields: any[];
  handleChange: any;
}) {
  const url = map(field?.assigned_field_options?.params, (value) => {
    return `${value.name}=${form.values[value.form_field_key ?? ""]}`;
  }).join("&");

  //   const [fieldOptions, setFieldOptions] = useState<any>([]);

  const { data: values, refetch } = useQuery({
    queryKey: [field?.field_options?.url],
    queryFn: async () => {
      const { data: response } = await axios.get(
        field?.assigned_field_options?.is_dependent
          ? `${field?.field_options?.url}${
              field?.field_options?.is_already_param_exist ? "&" : ""
            }${
              field?.field_options?.is_already_param_exist
                ? `${url}`
                : `?${url}`
            }`
          : field?.field_options?.url,
        {
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${_authState.authToken}`,
            "fi-client-number": CLIENT_ID.toUpperCase(),
            "fi-device-number": _authState.activeDeviceIdentifier,
          },
        }
      );

      const records = isArray(response?.data?.recordsInfo)
        ? response?.data?.recordsInfo
        : isArray(response?.data)
        ? response?.data
        : [];

      const value = records.map((data: any) => {
        return {
          label: data.label,
          value: String(data.value),
        };
      });

      return value;
    },
    enabled: field?.assigned_field_options?.is_dependent ? false : true,
    refetchOnWindowFocus: false,
  });

  const hasValue =
    form.values[field?.assigned_field_options?.parent_field_name ?? ""];

  useEffect(() => {
    if (hasValue !== null && hasValue !== undefined && hasValue !== "") {
      refetch();
    }
  }, [hasValue, refetch]);

  return (
    <>
      <Select
        clearable
        searchable
        label={field.label}
        placeholder={field.placeholder}
        withAsterisk={field?.validations?.required}
        readOnly={field?.is_readonly === 1 ? true : false}
        disabled={field?.is_readonly === 1 ? true : false}
        data={
          field?.assigned_field_options?.is_dependent && hasValue
            ? values ?? []
            : !field?.assigned_field_options?.is_dependent
            ? values ?? []
            : []
        }
        {...form.getInputProps(field.name)}
        onChange={(value) => {
          handleChange(value);

          field?.assigned_field_options?.children_fields?.forEach(
            (field: any) => {
              const childrenField = fields.find(
                (value) => value.name === field
              );

              const isArrayField =
                childrenField.type === "checkbox" ||
                childrenField.type === "multi_select";

              form.setFieldValue(field, isArrayField ? [] : null);
            }
          );
        }}
      />
    </>
  );
}

function MultiSelectField({
  form,
  value,
  field,
  fields,
  handleChange,
}: {
  form: any;
  value: any;
  field: any;
  fields: any;
  handleChange: any;
}) {
  const [fieldOptions, setFieldOptions] = useState<any>([]);

  const _field = useField({
    initialValue: value ?? "",
    onValueChange: (value) => {
      handleChange(value);
    },
    validateOnChange: true,
    validate: (value) => {
      if (field?.validations?.required && value === "") {
        return "Field is required";
      }
    },
  });

  useEffect(() => {
    if (field?.field_options?.type === "manual") {
      setFieldOptions(field?.field_options?.options);
    }
  }, [field]);

  return (
    <MultiSelect
      label={field.label}
      placeholder={field.placeholder}
      withAsterisk={field?.validations?.required}
      readOnly={field?.is_readonly === 1 ? true : false}
      disabled={field?.is_readonly === 1 ? true : false}
      data={fieldOptions}
      {..._field.getInputProps()}
    />
  );
}

function APIMultiSelectField({
  form,
  value,
  field,
  fields,
  handleChange,
}: {
  form: any;
  value: any;
  field: any;
  fields: any[];
  handleChange: any;
}) {
  const url = map(field?.assigned_field_options?.params, (value) => {
    return `${value.name}=${form.values[value.form_field_key ?? ""]}`;
  }).join("&");

  //   const [fieldOptions, setFieldOptions] = useState<any>([]);

  const { data: values, refetch } = useQuery({
    queryKey: [field?.field_options?.url],
    queryFn: async () => {
      const { data: response } = await axios.get(
        field?.assigned_field_options?.is_dependent
          ? `${field?.field_options?.url}${
              field?.field_options?.is_already_param_exist ? "&" : ""
            }${
              field?.field_options?.is_already_param_exist
                ? `${url}`
                : `?${url}`
            }`
          : field?.field_options?.url,
        {
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${Cookies.get("session")}`,
            "fi-client-number": CLIENT_ID.toUpperCase(),
            "fi-device-number": _authState.activeDeviceIdentifier,
          },
        }
      );

      const records = isArray(response?.data?.recordsInfo)
        ? response?.data?.recordsInfo
        : isArray(response?.data)
        ? response?.data
        : [];

      const value = records.map((data: any) => {
        return {
          label: data.label,
          value: String(data.value),
        };
      });

      return value;
    },
    enabled: field?.assigned_field_options?.is_dependent ? false : true,
    refetchOnWindowFocus: false,
  });

  const hasValue =
    form.values[field?.assigned_field_options?.parent_field_name ?? ""];

  useEffect(() => {
    if (hasValue !== null && hasValue !== undefined && hasValue !== "") {
      refetch();
    }
  }, [hasValue, refetch]);

  return (
    <>
      <MultiSelect
        clearable
        searchable
        label={field?.label}
        placeholder={field?.placeholder}
        withAsterisk={field?.validations?.required}
        readOnly={field?.is_readonly === 1 ? true : false}
        disabled={field?.is_readonly === 1 ? true : false}
        data={
          field?.assigned_field_options?.is_dependent && hasValue
            ? values ?? []
            : !field?.assigned_field_options?.is_dependent
            ? values ?? []
            : []
        }
        nothingFoundMessage="No options found"
        {...form.getInputProps(field.name)}
        onChange={(value) => {
          handleChange(value);

          field?.assigned_field_options?.children_fields?.forEach(
            (field: any) => {
              const childrenField = fields.find(
                (value) => value.name === field
              );

              const isArrayField =
                childrenField.type === "checkbox" ||
                childrenField.type === "multi_select";

              form.setFieldValue(field, isArrayField ? [] : null);
            }
          );
        }}
      />
    </>
  );
}

function DateField({
  form,
  value,
  field,
  fields,
  handleChange,
}: {
  form: any;
  value: any;
  field: any;
  fields: any;
  handleChange: any;
}) {
  const _field = useField({
    // initialValue: undefined,
    initialValue: !value
      ? undefined
      : value && isDate(new Date(value))
      ? new Date(value)
      : undefined,
    onValueChange: (value) => {
      handleChange(value);
    },
    validateOnChange: true,
    validate: (value) => {
      if (field?.validations?.required && isNil(value)) {
        return "Field is required";
      }
    },
  });

  return (
    <>
      <DateInput
        label={field.label}
        placeholder={field.placeholder}
        withAsterisk={field?.validations?.required}
        readOnly={field?.is_readonly === 1 ? true : false}
        disabled={field?.is_readonly === 1 ? true : false}
        {...(field?.validations?.after &&
          !isNil(field?.validations?.after) &&
          isDate(new Date(field?.validations?.after)) && {
            minDate: new Date(field?.validations?.after),
          })}
        {...(field?.validations?.before &&
          !isNil(field?.validations?.before) &&
          isDate(new Date(field?.validations?.before)) && {
            maxDate: new Date(field?.validations?.before),
          })}
        {...(field?.validations?.range &&
          field?.validations?.range?.length === 2 &&
          !isNil(field?.validations?.range[0]) &&
          !isNil(field?.validations?.range[1]) &&
          isDate(new Date(field?.validations?.range[0])) &&
          isDate(new Date(field?.validations?.range[1])) && {
            minDate: new Date(field?.validations?.range[0]),
            maxDate: new Date(field?.validations?.range[1]),
          })}
        {..._field.getInputProps()}
        onChange={(value: any) => {
          _field.setValue(value);
        }}
      />
    </>
  );
}

function TimeField({
  form,
  value,
  field,
  fields,
  handleChange,
}: {
  form: any;
  value: any;
  field: any;
  fields: any;
  handleChange: any;
}) {
  const _field = useField({
    initialValue: undefined,
    // initialValue: isNil(value)
    //   ? ""
    //   : isDate(new Date(value))
    //   ? dayjs(value).format("HH:mm:ss")
    //   : "",
    onValueChange: (value) => {
      handleChange(value);
    },
    validateOnChange: true,
    validate: (value) => {
      if (field?.validations?.required && isNil(value)) {
        return "Field is required";
      }
    },
  });

  return (
    <TimeInput
      label={field.label}
      placeholder={field.placeholder}
      withAsterisk={field?.validations?.required}
      readOnly={field?.is_readonly === 1 ? true : false}
      disabled={field?.is_readonly === 1 ? true : false}
      {..._field.getInputProps()}
    />
  );
}

function DateTimeField({
  form,
  value,
  field,
  fields,
  handleChange,
}: {
  form: any;
  value: any;
  field: any;
  fields: any;
  handleChange: any;
}) {
  const _field = useField({
    initialValue: isNil(value)
      ? null
      : isDate(new Date(value))
      ? new Date(value)
      : null,
    onValueChange: (value) => {
      handleChange(value);
    },
    validateOnChange: true,
    validate: (value) => {
      if (field?.validations?.required && isNil(value)) {
        return "Field is required";
      }
    },
  });

  return (
    <DateTimePicker
      label={field.label}
      placeholder={field.placeholder}
      withAsterisk={field?.validations?.required}
      readOnly={field?.is_readonly === 1 ? true : false}
      disabled={field?.is_readonly === 1 ? true : false}
      {..._field.getInputProps()}
    />
  );
}

function CheckboxField({
  form,
  value,
  field,
  fields,
  handleChange,
}: {
  form: any;
  value: any;
  field: any;
  fields: any;
  handleChange: any;
}) {
  const _field = useField({
    initialValue: value ?? "",
    onValueChange: (value) => {
      handleChange(value);
    },
    validateOnChange: true,
    validate: (value) => {
      if (field?.validations?.required && value === "") {
        return "Field is required";
      }
    },
  });

  return (
    <Checkbox
      label={field.label}
      placeholder={field.placeholder}
      readOnly={field?.is_readonly === 1 ? true : false}
      disabled={field?.is_readonly === 1 ? true : false}
      {..._field.getInputProps()}
    />
  );
}

function RadioField({
  form,
  value,
  field,
  fields,
  handleChange,
}: {
  form: any;
  value: any;
  field: any;
  fields: any;
  handleChange: any;
}) {
  const [fieldOptions, setFieldOptions] = useState<any>([]);

  const _field = useField({
    initialValue: value ?? "",
    onValueChange: (value) => {
      handleChange(value);
    },
    validateOnChange: true,
  });

  useEffect(() => {
    if (field?.field_options?.type === "manual") {
      setFieldOptions(field?.field_options?.options);
    }
  }, [field]);

  return (
    <>
      <Radio.Group
        label={field.label}
        withAsterisk={field?.validations?.required}
        readOnly={field?.is_readonly === 1 ? true : false}
        {..._field.getInputProps()}
        onChange={(value) => {
          _field.setValue(value);

          const resetChildrenFields = zipObject(
            field?.assigned_field_options?.children_fields,
            field?.assigned_field_options?.children_fields?.map(() => undefined)
          );

          form.setValues(resetChildrenFields);
        }}
      >
        <Group mt="xs">
          {fieldOptions?.map((option: any) => {
            return (
              <Radio
                key={option.value}
                value={option.value}
                label={option.label}
              />
            );
          })}
        </Group>
      </Radio.Group>
    </>
  );
}

function TextAreaField({
  form,
  value,
  field,
  fields,
  handleChange,
}: {
  form: any;
  value: any;
  field: any;
  fields: any;
  handleChange: any;
}) {
  const _field = useField({
    initialValue: value ?? "",
    onValueChange: (value) => {
      handleChange(value);
    },
    validateOnChange: true,
    validate: (value) => {
      if (field?.validations?.required && value === "") {
        return "Field is required";
      }
    },
  });

  return (
    <Textarea
      label={field.label}
      placeholder={field.placeholder}
      withAsterisk={field?.validations?.required}
      readOnly={field?.is_readonly === 1 ? true : false}
      disabled={field?.is_readonly === 1 ? true : false}
      {..._field.getInputProps()}
    />
  );
}

function evaluateCondition(
  field: string,
  operation: string,
  action: string,
  value: any
) {
  switch (operation) {
    case "contains":
      return action === "show"
        ? field?.includes(action)
        : !field?.includes(action);
    case "is":
    case "equals":
      return action === "show" ? field === value : !field === value;
    // return false;
    default:
      return false;
  }
}

export default function Field({
  form,
  field,
  fields,
  value,
  onChange,
}: {
  form: any;
  field: any;
  fields: any;
  value: any;
  onChange?: any;
}) {
  return (
    <>
      <If condition={field?.conditionally_visible === 1}>
        <Then>
          <If
            condition={evaluateCondition(
              form.values[field?.validations?.render_if?.field],
              field?.validations?.render_if?.operator,
              field?.validations?.render_if?.action,
              field?.validations?.render_if?.value
            )}
          >
            <Then>
              <FieldByType
                form={form}
                field={field}
                fields={fields}
                value={value}
                onChange={onChange}
              />
            </Then>
          </If>
        </Then>
        <Else>
          <FieldByType
            form={form}
            field={field}
            fields={fields}
            value={value}
            onChange={onChange}
          />
        </Else>
      </If>
    </>
  );
}

function FieldByType({
  form,
  field,
  fields,
  value,
  onChange,
}: {
  form: any;
  field: any;
  fields: any;
  value: any;
  onChange?: any;
}) {
  const _field = useField({
    initialValue: value ?? "",
    onValueChange: (value) => {
      handleChange(value);
    },
    validateOnChange: true,
    validate: (value) => {
      if (field?.validations?.required && value === "") {
        return "Field is required";
      }
      if (field?.validations?.min && value.length < field.validations.min) {
        return `Minimum ${field.validations.min} characters`;
      }
      if (field?.validations?.max && value.length > field.validations.max) {
        return `Maximum ${field.validations.max} characters`;
      }
      if (field?.type === "mobile") {
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
          return "Invalid email address";
        }
      }
      if (field?.type === "number") {
        if (!/^[0-9]+$/.test(value)) {
          return "Invalid number";
        }
      }
    },
  });

  const [, handleChange] = useUncontrolled({
    value: _field.getValue(),
    onChange: (value) => {
      onChange(value);
    },
  });

  if (field?.type === "email")
    return (
      <TextField
        form={form}
        value={value ?? ""}
        field={field}
        fields={fields}
        handleChange={handleChange}
      />
    );

  if (field?.type === "mobile")
    return (
      <PhoneNumberField
        form={form}
        value={value}
        field={field}
        fields={fields}
        handleChange={handleChange}
      />
    );

  if (field?.type === "text")
    return (
      <TextField
        form={form}
        value={value ?? ""}
        field={field}
        fields={fields}
        handleChange={handleChange}
      />
    );

  if (field?.type === "number")
    return (
      <NumberField
        form={form}
        value={value ?? ""}
        field={field}
        fields={fields}
        handleChange={handleChange}
      />
    );

  if (field?.type === "single_select") {
    if (field?.field_options?.type === "manual") {
      return (
        <SelectField
          form={form}
          value={value ?? ""}
          field={field}
          fields={fields}
          handleChange={handleChange}
        />
      );
    } else if (field?.field_options?.type === "api") {
      return (
        <APISelectField
          form={form}
          value={value ?? ""}
          field={field}
          fields={fields}
          handleChange={handleChange}
        />
      );
    }
  }

  if (field?.type === "multi_select")
    if (field?.field_options?.type === "manual") {
      return (
        <MultiSelectField
          form={form}
          value={value ?? ""}
          field={field}
          fields={fields}
          handleChange={handleChange}
        />
      );
    } else if (field?.field_options?.type === "api") {
      return (
        <APIMultiSelectField
          form={form}
          value={value ?? ""}
          field={field}
          fields={fields}
          handleChange={handleChange}
        />
      );
    }

  if (field?.type === "radio")
    return (
      <RadioField
        form={form}
        value={value}
        field={field}
        fields={fields}
        handleChange={handleChange}
      />
    );
  if (field?.type === "checkbox")
    return (
      <CheckboxField
        form={form}
        value={value}
        field={field}
        fields={fields}
        handleChange={handleChange}
      />
    );

  if (field?.type === "date")
    return (
      <DateField
        form={form}
        value={value}
        field={field}
        fields={fields}
        handleChange={handleChange}
      />
    );

  if (field?.type === "time")
    return (
      <TimeField
        form={form}
        value={value}
        field={field}
        fields={fields}
        handleChange={handleChange}
      />
    );

  if (field?.type === "datetime")
    return (
      <DateTimeField
        form={form}
        value={value}
        field={field}
        fields={fields}
        handleChange={handleChange}
      />
    );

  if (field?.type === "textarea")
    return (
      <TextAreaField
        form={form}
        value={value}
        field={field}
        fields={fields}
        handleChange={handleChange}
      />
    );

  return <></>;
}
